import { render, staticRenderFns } from "./AppearanceEditor.vue?vue&type=template&id=061eb63c&scoped=true&"
import script from "./AppearanceEditor.vue?vue&type=script&lang=js&"
export * from "./AppearanceEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppearanceEditor.vue?vue&type=style&index=0&id=061eb63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061eb63c",
  null
  
)

export default component.exports